/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
export const ListContext = /*#__PURE__*/React.createContext();
export function ListProvider(props) {
  const {
    children,
    listSelectionType,
    listSearchInputProps,
    selectedList,
    bulkActionMetaData,
    noSearchListMessage,
    noListMessage,
    isNoSearchResult
  } = props;
  return /*#__PURE__*/React.createElement(ListContext.Provider, {
    value: {
      listSelectionType,
      listSearchInputProps,
      selectedList,
      bulkActionMetaData,
      noSearchListMessage,
      noListMessage,
      isNoSearchResult
    }
  }, children);
}
ListContext.propTypes = {
  listSelectionType: PropTypes.string,
  children: PropTypes.node.isRequired,
  selectedList: PropTypes.array,
  listSearchInputProps: PropTypes.object,
  bulkActionMetaData: PropTypes.object,
  noListMessage: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({
    text: PropTypes.string.isRequired,
    subtext: PropTypes.string,
    actionButtonProps: PropTypes.object
  })]),
  isNoSearchResult: PropTypes.bool,
  noSearchListMessage: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({
    text: PropTypes.string.isRequired,
    subtext: PropTypes.string,
    actionButtonProps: PropTypes.object
  })])
};